import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import { useLanguage } from "../../context/LanguageContext";

const FAQSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-[#FAF8F5]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block text-center">{t.faq.label}</span>
        <h2 className="font-heading text-3xl md:text-4xl text-[#2D2926] text-center mb-12" data-testid="faq-title">{t.faq.title}</h2>
        <div className="bg-white shadow-lg">
          <Accordion type="single" collapsible className="divide-y divide-[#B5613B]/10">
            {t.faq.questions.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-none" data-testid={`faq-item-${index}`}>
                <AccordionTrigger className="text-left px-6 py-6 text-[#2D2926] hover:text-[#B5613B] transition-colors font-heading text-lg hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-[#6B6560] leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
